import React from "react"

import "../style/bulma.css"
import "../style/coolharbour-tech.css"
import "../style/coolharbour-gentext.css"
import "../style/coolharbour-tech-internal-livelab.css"


import Layout from "../components/layout"
import Packaginginternalbanner from "../components/internalpages/packagingprocess/packaginginternalbanner"

import Contactform from "../components/homepage/contactform"
import SEO from "../components/seo"
import Coolfooter from "../components/coolfooter"

const Contactpage = () => (
  <Layout>
    <SEO title="Contact Cool Harbour" />
    <Packaginginternalbanner />
   <Contactform />
   <Coolfooter />
  </Layout>
)

export default Contactpage